// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G8HIiu{display:flex;align-items:center;justify-content:center;padding:12px 0}.G8HIiu .x9Psc3{display:inline-block;margin-left:6px;cursor:pointer}.G8HIiu .O4WqEf{cursor:pointer}.G8HIiu>div{margin:0 6px}.G8HIiu>div:first-child{margin-left:0}.G8HIiu>div:last-child{margin-right:0}.XLBhwk{margin-left:-4px;margin-top:5px}.j2f2KW{display:inline-block;margin-left:-4px;margin-top:15px}.XppLUD{float:right}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"links": `G8HIiu`,
	"link": `x9Psc3`,
	"icon": `O4WqEf`,
	"mainLinksWrapper": `XLBhwk`,
	"episodeLinksWrapper": `j2f2KW`,
	"feedLinksWrapper": `XppLUD`
};
export default ___CSS_LOADER_EXPORT___;
